export default __webpack_public_path__ + "static/media/halog-logo-color.6ea26dec.png";